/** DVA namespace — must match `model.js` and route registration. */
export const MODEL_NAME = 'emailFormats';

/** API route prefix — shared by `model.js` (createCrudModel) and list descriptor routes. */
export const FETCH_ROUTE = 'emailNotificationTemplate';

/** Singular entity name for `createCrudModel` reducers/notifications. */
export const ENTITY_NAME = 'emailFormat';

/** CoreQueries key for paged/detail OData shapes. */
export const FETCH_PARAMS = 'emailNotificationTemplate';

/** i18n resource key for form drawer hero summary (`configForm.hero.summary.resource.{key}.*`). */
export const FORM_RESOURCE_KEY = 'emailFormats';

/** Public file URL module segment for view/download of templates. */
export const PUBLIC_FILE_MODULE = 'email-notification-template';
